export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-foreground-900 text-white">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-planet-line text-base"></i>
              </span>
              <span className="font-heading text-lg">51吃瓜视频</span>
            </div>
            <p className="text-sm text-white/60 leading-relaxed">
              百万吃瓜群众的聚集地，娱乐圈热门事件追踪，51吃瓜大赛与暗网吃瓜独家内容，台北娜娜前线报道，带你围观最精彩的八卦世界。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base mb-4">快速导航</h4>
            <div className="space-y-2">
              {[
                { href: '#index', label: '专题合集' },
                { href: '#ranking', label: '热度榜单' },
                { href: '#updates', label: '最新快讯' },
                { href: '#carousel', label: '焦点专题' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavClick(item.href);
                  }}
                  className="block text-sm text-white/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base mb-4">热门板块</h4>
            <div className="space-y-2">
              {[
                { href: '#comments', label: '吃瓜热评' },
                { href: '#media', label: '精彩视频' },
                { href: '#cards', label: '热门推荐' },
                { href: '#topics', label: '热门话题' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavClick(item.href);
                  }}
                  className="block text-sm text-white/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base mb-4">合作伙伴</h4>
            <p className="text-sm text-white/40 leading-relaxed">
              更多合作伙伴信息敬请期待。如有合作意向，欢迎通过「联系我们」板块与我们取得联系。
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40">
            &copy; 2026 51吃瓜视频 - 吃瓜群众八卦社区。本站内容仅供娱乐参考，不构成任何投资或法律建议。
          </p>
          <div className="flex items-center gap-4 text-xs text-white/40">
            <span className="cursor-pointer hover:text-white/60 transition-colors">用户协议</span>
            <span className="cursor-pointer hover:text-white/60 transition-colors">隐私政策</span>
            <span className="cursor-pointer hover:text-white/60 transition-colors">社区规范</span>
          </div>
        </div>
      </div>
    </footer>
  );
}